import { getCadenzaTopWindow } from '@disy/lib/iframe';

/**
 * Returns the `window.location` and can be mocked in tests.
 *
 * Mocking/Spying on the location is otherwise not possible.
 * @see https://github.com/jsdom/jsdom/issues/3492
 */
export function getLocation() {
  return getCadenzaTopWindow().location;
}
